// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"55ad2ebc","239":"b34a43bd","453":"6cae3082","455":"5d19e886","461":"6103098f","507":"a1c966a4"}[chunkId] + ".chunk.js";
};